import React, { useEffect, useRef, useState } from 'react';
import { Container, Nav } from 'react-bootstrap';

const CircleStepNavigation = ({ steps, currentStep, onStepClick, showLabels = true, NavLinkClassName, activeClassName = 'active', containerClassName = '', disabledSteps = [] }) => {
    let firstRef = useRef(null);
    let lastRef = useRef(null);
    let lineRef = useRef(null);
    let containerRef = useRef(null);
    let [lineStyle, setLineStyle] = useState({});

    useEffect(() => {
        let updateLine = () => {
            if (firstRef.current && lastRef.current && lineRef.current && containerRef.current) {
                let containerRect = containerRef.current.getBoundingClientRect();
                let firstRect = firstRef.current.getBoundingClientRect();
                let lastRect = lastRef.current.getBoundingClientRect();
                let firstCenter = firstRect.left + firstRect.width / 2 - containerRect.left;
                let lastCenter = lastRect.left + lastRect.width / 2 - containerRect.left;
                let width = lastCenter - firstCenter;
                setLineStyle({
                    left: `${firstCenter}px`,
                    width: `${width}px`,
                });
            }
        };
        updateLine();
        window.addEventListener('resize', updateLine);
        return () => window.removeEventListener('resize', updateLine);
    }, [steps]);

    return (
        <Container ref={containerRef} className={`circle-step-container position-relative ${containerClassName}`}>
            <div className="step-line" ref={lineRef} style={lineStyle} />
            <Nav className="justify-content-between flex-row row-cols-2 row-cols-sm-auto" as="nav">
                {steps.map((step, index) => {
                    const stepNumber = index + 1;
                    const isActive = stepNumber <= currentStep;
                    const isDisabled = disabledSteps.includes(stepNumber);
                    return (
                        <Nav.Item as="div" key={index} className="step-item text-center"
                            ref={ index === 0 ? firstRef : index === steps.length - 1 ? lastRef : null }>
                            <Nav.Link as="button" disabled={isDisabled}
                                className={`step-circle-btn ${isActive ? activeClassName : NavLinkClassName} ${isDisabled ? 'disabled' : ''}`}
                                onClick={() => !isDisabled && onStepClick(stepNumber)}
                            >
                                {stepNumber}
                            </Nav.Link>
                            {showLabels && <div className="step-label">{step}</div>}
                        </Nav.Item>
                    );
                })}
            </Nav>
        </Container>
    );
};

export default CircleStepNavigation;
